export default {"src":"/_next/static/media/potion-logo.eec186a8.svg","height":38,"width":150};